import * as jsxRuntime from "C:\\Eidos!!!\\fredhus\\64-frederiks-hus\\node_modules\\react\\jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment